import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useAuth } from "./AuthProvider";
import { LAST_AUTH_CLIENT_KEY, storeAuthReturnTo } from "./auth-return-url";
import { Loader } from "../../@bloodline";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, login, clients } = useAuth();
  const location = useLocation();
  const automaticLoginStarted = useRef(false);
  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  const rememberedClient = clients.find((client) => client.id === localStorage.getItem(LAST_AUTH_CLIENT_KEY));
  const automaticClient = clients.length === 1 ? clients[0] : rememberedClient;

  useEffect(() => {
    if (isLoading || isAuthenticated) return;

    storeAuthReturnTo(returnTo);
    if (automaticClient && !automaticLoginStarted.current) {
      automaticLoginStarted.current = true;
      void login(automaticClient.id);
    }
  }, [automaticClient, isAuthenticated, isLoading, login, returnTo]);

  if (isLoading) return <Loader />;

  if (!isAuthenticated) {
    if (automaticClient) return <Loader />;

    return (
      <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center gap-4 p-6">
        <div>
          <h1 className="text-2xl font-semibold">Choose an account</h1>
          <p className="mt-2 text-muted-foreground">Sign in to continue to the page you requested.</p>
        </div>
        {clients.length > 1 ? (
          <div className="flex flex-col gap-2">
            {clients.map((client) => (
              <button
                key={client.id}
                type="button"
                className="rounded-md border border-border px-4 py-3 text-left hover:bg-secondary"
                onClick={() => {
                  storeAuthReturnTo(returnTo);
                  localStorage.setItem(LAST_AUTH_CLIENT_KEY, client.id);
                  void login(client.id);
                }}
              >
                Continue with {client.name}
              </button>
            ))}
          </div>
        ) : (
          <p role="alert" className="text-sm text-destructive">
            No sign-in accounts are currently available. Please try again shortly.
          </p>
        )}
      </main>
    );
  }

  return <Outlet />;
}
